import { USER_DEVICE } from './types'

export const setUserDevice = (status) => {
  return {
    type: USER_DEVICE,
    payload: status,
  }
}
